import { render, staticRenderFns } from "./AdministrationForms.vue?vue&type=template&id=3b128968&scoped=true&"
import script from "./AdministrationForms.vue?vue&type=script&lang=js&"
export * from "./AdministrationForms.vue?vue&type=script&lang=js&"
import style0 from "./AdministrationForms.vue?vue&type=style&index=0&id=3b128968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b128968",
  null
  
)

export default component.exports